<template>
	<TableView v-if="showTableView" :col="columns" :getData="getData" :Options="{tblClass:'table-striped table-bordered'}" />           
</template>
<script>
import common from '@/assets/js/common.js';
import { mapActions } from 'vuex';
export default {
  components: {
    TableView : () => import('@/components/Common/DataTable/Table') ,
  },
  mixins: [common],
  props: ['report_date', 'account_numbers'],
  data(){
  	return {
      showTableView: false,
      res: {},
      columns: (() => {
        const cols = [
          
        ]
        const groupsDef = {
          Normal: [],
          Sortable: [],
          Extra: ['Operation']
        }
        return cols.map(col => {
          if(!this.can_view_field('report', col.nested?col.nested:col.field) && col.title != 'Operation') col.visible = false;
          Object.keys(groupsDef).forEach(groupName => {
            if (groupsDef[groupName].includes(col.title)) {
              col.group = groupName
            }
          })
          return col
        })
      })(),
  	}
  },
  mounted() {
      if(this.account_numbers != null){
        this.changeBodyLoading(true);
        let uri = 'seurity_reconciliation_report?report_date='+this.report_date[1];
        if(this.account_numbers.filter(val => val == 'ALL').length == 0)
            uri  = uri+'&account_number='+this.account_numbers.join(',');
        this.call_axios(uri).then(res => {
            this.res = res;
            this.columns = [
              
            ];
            Object.keys(res.response.data.header.custodians).forEach((v, k) => {
                if(k==0)
                    this.columns.push({ title: 'Ticker', field: 'ticker', thClass: "leftfixed", tdClass: "leftfixed", tdStyle: {padding: "0.8rem !important"}});
                this.columns.push({ title: res.response.data.header.custodians[v], field: 'quantity', nested: 'custodians.'+v, visible: 'true', tdComp: 'fourD-Arr-Number', 'floatLength': 2});
            })
            this.columns.push({ title: 'Total', field: 'quantity', nested: 'custodians.total', visible: 'true', tdComp: 'threeD-Arr-Number', 'floatLength': 2});

            Object.keys(res.response.data.header.accounts).forEach((v, k) => {
                this.columns.push({ title: v, field: 'quantity', nested: 'accounts.'+v, visible: 'true', tdComp: 'fourD-Arr-Number', 'floatLength': 2});
            })
            this.columns.push({ title: 'Total', field: 'quantity', nested: 'accounts.total', visible: 'true', tdComp: 'threeD-Arr-Number', 'floatLength': 2});

            this.showTableView = true;
            this.changeBodyLoading(false);
        });
      }
  },
  methods: {
    ...mapActions('layout', ['changeBodyLoading']),
    async getData(query, filter) {
      return this.res;
    }
  }
}
</script>
<style>
.header-bar{
  text-align: center;
  vertical-align: middle !important;
  font-weight: 700;
  color:#fff;
  padding: 10px 0 0 0;
}
</style>